import(/* webpackMode: "eager", webpackExports: ["FundDocument"] */ "/vercel/path0/components/work/FundDocument.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchHistoryTracker"] */ "/vercel/path0/components/work/SearchHistoryTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkDocumentTracker"] */ "/vercel/path0/components/WorkDocumentTracker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
